import { ActionEnum } from "../enums/actionEnum";
import { ActivityReportEnum } from "../enums/activityReportEnum";

export class SyncLog {
  id?: number;
  originId: string;
  errorMessage: string;
  action: ActionEnum;
  activityReport: ActivityReportEnum;
  createdAt: string;

  constructor(data?: Partial<SyncLog>) {
    this.id = data?.id;
    this.originId = data?.originId;
    this.errorMessage = data?.errorMessage ?? '';
    this.action = data?.action;
    this.activityReport = data?.activityReport;
    this.createdAt = data?.createdAt ?? new Date().toISOString();
  }
}
